module.exports = __webpack_public_path__ + "static/media/mazaZolePlayed_10_1010.2413ec78.png";